
// core components
import React from "react";
import StatusPageHeader from "../../../components/Headers/StatusPageHeader";

class Status404Page extends React.Component {
  render() {
    return (
      <>
        <StatusPageHeader
          title="404!"
          lead="Looks like you are lost. The page you are looking for isn't found. Please try again!"
          btnURL="/"
        />
      </>
    );
  }
}

export default Status404Page;
